import { useState } from 'react';
import TabSelector from 'modules/common/components/TabSelector';
import ScansProvidersContainer from './ScansProvidersContainer';
import { PageTabs, PageTabsOptions } from './helper';
import { Container, Wrapper } from './style';
import ScansServicesContainer from './ScansServicesContainer';

const ScansProvidersAndServicesContainerSelectorPage = () => {
  const [selectedTabOption, setSelectedTabOption] = useState(PageTabs.Providers);
  return (
    <Container>
      <Wrapper>
        <TabSelector
          onChange={payload => {
            setSelectedTabOption(payload.value);
          }}
          options={PageTabsOptions}
          value={selectedTabOption}
        />
        {selectedTabOption === PageTabs.Providers && <ScansProvidersContainer />}
        {selectedTabOption === PageTabs.Services && <ScansServicesContainer />}
      </Wrapper>
    </Container>
  );
};

ScansProvidersAndServicesContainerSelectorPage.propTypes = {};

ScansProvidersAndServicesContainerSelectorPage.defaultProps = {};

export default ScansProvidersAndServicesContainerSelectorPage;
